module.exports = __webpack_public_path__ + "img/icon-3.a0ef7c13.svg";